import { FC } from 'react';
import { Flex, FlexProps, Text, theme } from '@chakra-ui/react';
import Coins from '../../assets/Coins';
import { formatNumber, pluralize } from 'ui/helpers/numbers';
export interface CbChestsPrizeTokensProps extends FlexProps {
  amount: number;
}
export const CbChestsPrizeTokens: FC<CbChestsPrizeTokensProps> = ({
  amount,
  ...props
}) => {
  return <Flex alignItems="center" {...props} data-sentry-element="Flex" data-sentry-component="CbChestsPrizeTokens" data-sentry-source-file="CbChestsPrizeTokens.tsx">
      <Coins marginRight={2} width={['58px', '88px']} height="auto" position="relative" zIndex={theme.zIndices.docked} data-sentry-element="Coins" data-sentry-source-file="CbChestsPrizeTokens.tsx" />
      <Text position="relative" whiteSpace="nowrap" data-sentry-element="Text" data-sentry-source-file="CbChestsPrizeTokens.tsx">
        {`${formatNumber(amount)} ${pluralize(amount, 'Token')}!`}
      </Text>
    </Flex>;
};